import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { FormikErrors, FormikTouched } from 'formik';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ForeignForm } from 'shell/components/shared/sipo-person-form/new-person';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';

interface ForeignComponentProps {
  disabled?: boolean;
  isEditMode?: boolean;
  values?: ForeignForm;
  errors?: FormikErrors<ForeignForm>;
  touched?: FormikTouched<ForeignForm>;
  onChange: (key: keyof ForeignForm, value: ForeignForm[keyof ForeignForm]) => void;
  labelState?: string;
  labelMunicipality?: string;
}

const ForeignComponent = ({
  disabled,
  isEditMode,
  values,
  errors,
  touched,
  onChange,
  labelState = 'Stato estero di nascita',
  labelMunicipality = 'Comune estero di nascita',
}: ForeignComponentProps): React.ReactElement => {
  const handleForeignStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('state', state);
    }
  );

  const handleInputKeyboardChange = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    onChange('municipality', municipality);
  });

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={6}>
        <ForeignStateList
          value={values?.state || null}
          onChange={handleForeignStateListChange}
          disabled={isEditMode ? false : disabled}
          label={labelState}
          required
          id="foreignStateBirth"
          error={
            (touched?.state as FormikTouched<ForeignStateVM>) &&
            Boolean(errors?.state as FormikErrors<ForeignStateVM>)
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MunicipalityForeignList
          value={values?.municipality || null}
          onChange={handleInputKeyboardChange}
          label={labelMunicipality}
          required
          id="foreignMunicipality"
          disabled={!values?.state?.id}
          foreignStateIstatCode={values?.state?.id}
          error={Boolean(errors?.municipality as FormikErrors<MunicipalityAnprVM>)}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="county"
          name="county"
          fullWidth
          disabled
          type="text"
          variant="outlined"
          value={values?.state?.province || ''}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

ForeignComponent.displayName = 'Foreign generality component';

const Foreign = memo(ForeignComponent);

export default Foreign;
